import { useIsVisible } from "@website/hooks/is-visible";
import { LazyImagePropertiesType } from "@website/ui-old/lazy-image/lazy-image.types";
import omit from "lodash-es/omit";
import { FC, memo, RefObject, useRef } from "react";

const LazyImage: FC<LazyImagePropertiesType> = (properties) => {
  const { src, fallback, loading = "lazy", pictures } = properties;
  const { reference, inView } = useIsVisible();
  const showImage = useRef<boolean>(false);

  if (inView) {
    showImage.current = true;
  }

  if (reference.current && "loading" in reference.current) {
    showImage.current = true;
  }

  const Image = (
    <img
      {...omit(properties, "loading", "fallback", "src")}
      alt={properties?.alt}
      loading={loading}
      ref={reference as RefObject<HTMLImageElement>}
      src={showImage.current ? src : fallback}
    />
  );

  if (pictures) {
    return (
      <picture>
        {pictures.map((picture) => (
          <source
            key={picture.media}
            media={`(${picture.media})`}
            srcSet={picture.srcSet}
          />
        ))}
        {Image}
      </picture>
    );
  }

  return Image;
};

const LazyImageMemoized = memo(LazyImage);
/**
 * @deprecated please use @website/ui instead
 */
export { LazyImageMemoized /**
 * @deprecated please use @website/ui instead
 */ as LazyImage };
